/**
 * Decorative floating gradient orbs for section backgrounds.
 * Parent section must have position:relative and overflow-hidden.
 */
export function BgOrbs({ variant = "default" }: { variant?: "default" | "yellow" | "blue" }) {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {variant === "default" && (
        <>
          <div className="absolute -top-48 -right-32 w-[560px] h-[560px] rounded-full bg-[#1D3FE8] opacity-[0.06] blur-[100px]" />
          <div className="absolute -bottom-24 -left-32 w-[480px] h-[480px] rounded-full bg-[#F5C542] opacity-[0.10] blur-[90px]" />
          <div className="absolute top-1/3 right-1/3 w-[320px] h-[320px] rounded-full bg-[#1D3FE8] opacity-[0.04] blur-[70px]" />
        </>
      )}
      {variant === "yellow" && (
        <>
          <div className="absolute -top-32 -left-24 w-[440px] h-[440px] rounded-full bg-[#F5C542] opacity-[0.12] blur-[90px]" />
          <div className="absolute -bottom-16 -right-16 w-[380px] h-[380px] rounded-full bg-[#1D3FE8] opacity-[0.07] blur-[80px]" />
        </>
      )}
      {variant === "blue" && (
        <>
          <div className="absolute -top-24 -right-24 w-[500px] h-[500px] rounded-full bg-[#1D3FE8] opacity-[0.08] blur-[100px]" />
          <div className="absolute bottom-0 left-1/4 w-[360px] h-[360px] rounded-full bg-[#F5C542] opacity-[0.08] blur-[80px]" />
        </>
      )}
    </div>
  );
}
